
import { Avatar, Box, Grid, SkeletonText } from "@chakra-ui/react";

// Custom components
import Banner from "views/admin/profile/components/Banner";
import General from "views/admin/profile/components/General";
import Notifications from "views/admin/profile/components/Notifications";
// import Projects from "views/admin/profile/components/Projects";
// import Storage from "views/admin/profile/components/Storage";
import Upload from "views/admin/profile/components/Upload";
// import CheckTable from "../dataTables/components/CheckTable";
// Assets
import banner from "assets/img/auth/banner.png";
import avatar from "assets/img/avatars/avatar4.png";
import React, { useEffect, useState } from "react";
import ColumnsTable from "../profile/components/ColumnsTable";
import { TeacherTT } from "../profile/variables/columnsData";
import tableTeacherTT from "../profile/variables/tableTeacherTT.json"
import { useUserAuth } from "contexts/UserAuthContext";
export default function Overview() {

  const [data, setData] = useState(null)
  const { getUserProfile } = useUserAuth()
  const [isLoaded, setIsLoaded] = useState(false)
  useEffect(() => {
    getUserProfile().then((data) => {
      setData(data)
      setIsLoaded(true)
    })
    // Fetch user profile data when the component mounts
    // const fetchData = async () => {
    //   try {
    //     const {user} = useUserAuth()
    //     const profileData = await getUserProfile();
    //     // Do something with the profile data
    //      setData(profileData);
    //     console.log(profileData);
    //     setIsLoaded(true)

    //     console.log("HEEEEEEEEERRRRRRRRRRRREEEEEEEE")
    //   } catch (error) {
    //     console.error("Error fetching user profile", error);
    //   }
    // };

    // fetchData();




  }, []);
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      {/* Main Fields */}
      <Grid
        templateColumns={{
          base: "1fr",
          lg: "1.34fr 4fr",
        }}
        templateRows={{
          base: "repeat(3, 1fr)",
          lg: "1fr",
        }}
        gap={{ base: "20px", xl: "20px" }}>
        {!isLoaded ? (<Banner gridArea='1 / 1 / 2 / 2' name={<SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='2' />} />) : (<Banner gridArea='1 / 1 / 2 / 2' banner={banner} avatar={data.name} name={data.name} post={data.designation} dept={data.department} />)}

        {/* <Storage
          gridArea={{ base: "2 / 1 / 3 / 2", lg: "1 / 2 / 2 / 3" }}
          used={25.6}
          total={50}
        />*/}

        <ColumnsTable
          columnsData={TeacherTT}
          tableData={tableTeacherTT}
        />
      </Grid>
      {/* <Grid
        mb='20px'
        templateColumns={{
          base: "1fr",
          lg: "repeat(2, 1fr)",
          "2xl": "1.34fr 1.62fr 1fr",
        }}
        templateRows={{
          base: "1fr",
          lg: "repeat(2, 1fr)",
          "2xl": "1fr",
        }}
        gap={{ base: "20px", xl: "20px" }}>
        <Projects
          gridArea='1 / 2 / 2 / 2'
          banner={banner}
          avatar={avatar}
          name='Adela Parkson'
          job='Product Designer'
          posts='17'
          followers='9.7k'
          following='274'
        />
        <General
          gridArea={{ base: "2 / 1 / 3 / 2", lg: "1 / 2 / 2 / 3" }}
          minH='365px'
          pe='20px'
        />
        <Notifications
          used={25.6}
          total={50}
          gridArea={{
            base: "3 / 1 / 4 / 2",
            lg: "2 / 1 / 3 / 3",
            "2xl": "1 / 3 / 2 / 4",
          }}
        />
      </Grid> */}
    </Box>
  );
}
